/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc
 */
import * as References from './MarketplaceListingEditorRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc#getDetails
 */
export const GET_DETAILS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingEditorRpc_getDetails';
export const GET_DETAILS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetDetailsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_DETAILS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetDetailsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getDetailsRpc, {
      timeout: ctx.timeout,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc#getListingSummaries
 */
export const GET_LISTING_SUMMARIES_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingEditorRpc_getListingSummaries';
export const GET_LISTING_SUMMARIES_QUERY: RegisteredQuery<
  'result',
  References.GetListingSummariesRequestType,
  References.GetListingSummariesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LISTING_SUMMARIES_QUERY_FIELD_NAME,
  args: ['entryKeys'],
  fetcher(
    request: References.GetListingSummariesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetListingSummariesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getListingSummariesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc#getListingSummariesPage
 */
export const GET_LISTING_SUMMARIES_PAGE_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingEditorRpc_getListingSummariesPage';
export const GET_LISTING_SUMMARIES_PAGE_QUERY: RegisteredQuery<
  'result',
  References.GetListingSummariesPageRequestType,
  References.GetListingSummariesPageResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LISTING_SUMMARIES_PAGE_QUERY_FIELD_NAME,
  args: ['entryKeys', 'offset', 'pageLength'],
  fetcher(
    request: References.GetListingSummariesPageRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetListingSummariesPageResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getListingSummariesPageRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc#getDraftListing
 */
export const GET_DRAFT_LISTING_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingEditorRpc_getDraftListing';
export const GET_DRAFT_LISTING_QUERY: RegisteredQuery<
  'result',
  References.GetDraftListingRequestType,
  References.GetDraftListingResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_DRAFT_LISTING_QUERY_FIELD_NAME,
  args: ['listingId', 'language'],
  fetcher(
    request: References.GetDraftListingRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetDraftListingResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getDraftListingRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
